import { string } from "yup";

export default string()
  .min(6, "Please enter a password that contains at least 6 characters.")
  .matches(/\W/, "Your password must contain at least 1 special character.")
  .matches(/[0-9]/, "Your password must contain at least 1 number.")
  .matches(/[A-Z]/, "Your password must contain at least 1 uppercase letter.")
  .required("Please enter a password");
